<template>
  <div
    :class="{
      'video-layout': true,
      'video-room-maximized': !!videoRoom,
      'video-fullscreen': !!fullscreen,
    }"
  >
    <v-toolbar dense color="transparent" dark flat v-if="videoRoom">
      <v-spacer />
      <v-toolbar-title>{{ videoRoom.name }}</v-toolbar-title>
      <v-spacer />
      <v-btn @click="close" color="secondary" x-small fab>
        <v-icon size="28">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div ref="layoutContainer" class="layout_container">
      <div
        :class="videoRoom ? 'OT_root OT_big' : 'OT_ignore'"
        :style="`border-color: ${$store.state.event.brandingContentBackgroundColor}`"
      >
        <slot></slot>
      </div>
      <div ref="publisherContainer" v-if="videoRoom"></div>
    </div>
  </div>
</template>

<script>
import OT from "@opentok/client";

const initLayoutContainer = require("opentok-layout-js");

export default {
  name: "ParticipantVideoRoom",
  data() {
    return {
      session: null,
      layout: null,
    };
  },
  computed: {
    videoRoom() {
      return this.$store.state.videoRoom;
    },
    fullscreen() {
      return this.$store.state.fullscreenVideo;
    },
  },
  methods: {
    initializeLayoutContainer() {
      this.layout = initLayoutContainer(this.$refs.layoutContainer, {
        fixedRatio: true, // If this is true then the aspect ratio of the video is maintained and minRatio and maxRatio are ignored (default false)
        bigFixedRatio: false,
        bigMaxRatio: 9 / 16,
        bigMinRatio: 9 / 16,
        bigPercentage: this.$vuetify.breakpoint.mdAndUp ? 0.5 : 0.33,
      }).layout;
      this.layout();
    },
    displayParticipantName(subscriber) {
      const participantData = JSON.parse(subscriber.stream.connection.data);
      const node = document.createElement("div");
      node.className = "participant-name subtitle-1 text-center";
      node.appendChild(document.createTextNode(participantData.username));
      subscriber.element.appendChild(node);
    },
    close() {
      this.$store.commit("VIDEO_ROOM", null);
    },
    connectToVideoRoomSession() {
      this.session = OT.initSession(this.$store.state.openTokApiKey, this.$store.state.videoRoomOpenTokSession);
      this.session.connect(this.$store.state.videoRoomOpenTokToken, (error) => {
        if (error) {
          // handleError(error);
        } else {
          const publisher = this.session.publish(this.$refs.publisherContainer, () => {
            this.layout();
            this.displayParticipantName(publisher);
          });
          this.layout();
        }
      });
      this.session.on("streamCreated", (event) => {
        const subscriber = this.session.subscribe(
          event.stream,
          this.$refs.layoutContainer,
          {
            insertMode: "append",
          },
          () => {
            this.layout();
            this.displayParticipantName(subscriber);
          }
        );
      });
      this.layout();

      this.session.on("connectionDestroyed", () => this.layout());
    },
    async participantDisconnect() {
      await this.$axios.post(
        `/event/activities/sessionRooms/${this.$store.state.videoRoom.id}/leave/${this.$store.state.participantId}`
      );
    },
  },
  watch: {
    videoRoom(videoRoom) {
      if (videoRoom) {
        this.connectToVideoRoomSession();
        this.$store.commit("MAXIMIZED", true);
      } else {
        this.participantDisconnect();
        this.session.off();
        this.session.disconnect();
        this.$store.commit("MAXIMIZED", false);
        this.initializeLayoutContainer();
      }
    },
  },
  mounted() {
    this.initializeLayoutContainer();
    let resizeTimeout;
    window.onresize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => this.initializeLayoutContainer(), 20);
    };
  },
};
</script>

<style scoped lang="scss">
.video-layout {
  background-color: #1a1a1a;
  width: 100%;
  position: relative;
}

.OT_ignore {
  position: relative !important;
  width: auto !important;
  height: auto !important;
  top: 0 !important;
  left: 0 !important;
}

.video-room-maximized {
  height: 100vh;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;

  .layout_container > .OT_video-loading {
    border: 1px solid white;
  }

  .layout_container {
    position: relative;
    height: calc(100% - 48px);
  }

  .layout_container .participant-name {
    position: absolute;
    bottom: 0;
    width: 100%;
    color: white;
    background: rgba(40, 40, 40, 0.8);
    height: 28px;
  }

  .layout_container > .OT_root {
    border: 1px solid black;
    overflow: hidden;
  }

  .layout_container > .OT_publisher {
    border-color: white;
  }

  .layout_container > * {
    width: 0;
    height: 0;
    opacity: 0;
    transition-property: all;
    transition-duration: 0.5s;
  }

  .layout_container > *.ot-layout {
    opacity: 1;
  }
}

.video-fullscreen {
  height: 100vh;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
}

.video-fullscreen > header {
  height: 0 !important;
}

.video-fullscreen .OT_big {
  width: 100vw !important;
  height: 100vh !important;
  z-index: 30 !important;
  top: 0 !important;
  border: none !important;
}
</style>
